import { useState } from "react";
import { Link } from "react-router";
import { authFetch } from "../../lib/auth-fetch";

type FlushState = "idle" | "confirming" | "flushing" | "done";

const Admin = () => {
	const [flushState, setFlushState] = useState<FlushState>("idle");
	const [result, setResult] = useState<{ broadcasts: number; fixtures: number } | null>(null);
	const [error, setError] = useState<string | null>(null);

	const handleFlush = async () => {
		setFlushState("flushing");
		setError(null);
		try {
			const res = await authFetch("/api/admin/flush", { method: "POST" });
			const data = await res.json();
			if (!res.ok) {
				setError(data.error ?? "Flush failed");
				setFlushState("idle");
				return;
			}
			setResult(data.deleted);
			setFlushState("done");
		} catch {
			setError("Could not reach server");
			setFlushState("idle");
		}
	};

	return (
		<div>
			<p><Link to="/">← Back</Link></p>
			<h2>Admin</h2>

			<section>
				<h3>Data management</h3>
				<p>Delete all broadcasts and fixtures from Firestore. User accounts are preserved.</p>

				{flushState === "idle" && (
					<button type="button" onClick={() => setFlushState("confirming")}>
						Clear all broadcasts &amp; fixtures
					</button>
				)}

				{flushState === "confirming" && (
					<div>
						<p><strong>Are you sure?</strong> This permanently deletes all broadcasts, posts, lineups, and fixture data.</p>
						<button type="button" onClick={handleFlush}>Yes, delete everything</button>
						<button type="button" onClick={() => setFlushState("idle")}>Cancel</button>
					</div>
				)}

				{flushState === "flushing" && <p>Deleting…</p>}

				{flushState === "done" && result && (
					<p>
						Done — deleted {result.broadcasts} broadcast{result.broadcasts !== 1 ? "s" : ""} and {result.fixtures} fixture{result.fixtures !== 1 ? "s" : ""}.
					</p>
				)}

				{error && <p>{error}</p>}
			</section>
		</div>
	);
};

export default Admin;
